
export default function getDays(weekDays) {
    const splitWeekDays = weekDays.split('|');
    let listDays = [];
    const dayNames = ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday", "Sunday"];
    for (var i = 0; i < splitWeekDays.length; i++) {
        let num = parseInt(splitWeekDays[i]);
        listDays.push(dayNames[num - 1])
    }
    if (listDays.length == 1) {
        return listDays[0];
    }
    else if (listDays.length > 1) {
        let retValue = listDays[0];
        for (var i = 1; i < listDays.length; i++) {
            if (listDays.length - i > 1) {
                retValue = retValue + ', ' + listDays[i];
            }
            else if (listDays.length - i == 1) {
                retValue = retValue + ' & ' + listDays[i];
            }
        }
        return retValue;
    }
    return '';
}